import {Component} from '@angular/core';
import {OauthRedirectErrorCode} from '@npck/errors-api';
import {AnalyticsService} from '@npck/libs/analytics-sdk';
import {RouterService, Spinner} from '@npck/libs/commons';
import {OauthService} from '../../domain/oauth.service';
import {AUTH_REJECT} from '../../infra/analytics-events';
import {Path} from '../../path';

const SHOW_CANCEL_BUTTON_PATHS = [
    Path.CODE,
    Path.IIN,
    Path.BIN,
    Path.LIVENESS,
];

@Component({
    templateUrl: './auth.layout.component.html',
    styleUrls: ['auth.layout.component.scss'],
    standalone: false
})
export class AuthLayoutComponent {

    Path = Path;

    constructor(
        public routerService: RouterService,
        private analyticsService: AnalyticsService,
        private oauthService: OauthService,
    ) {
    }

    cancel(): void {
        Spinner.show('cancel');
        const code = this.getCancellationErrorCode();
        this.analyticsService.capture(AUTH_REJECT, {reason: code});
        this.oauthService.handleOauthErrorAndRedirect(code);
    }

    showCancelButton(): boolean {
        return SHOW_CANCEL_BUTTON_PATHS.includes(this.routerService.getCurrentUrl().slice(1) as Path);
    }

    private getCancellationErrorCode(): OauthRedirectErrorCode {
        switch (this.routerService.getCurrentUrl().slice(1)) {
            case Path.IIN:
                return OauthRedirectErrorCode.auth_iin_step_cancelled;
            case Path.CODE:
                return OauthRedirectErrorCode.auth_sms_code_cancelled;
            case Path.LIVENESS:
                return OauthRedirectErrorCode.auth_liveness_step_cancelled;
            case Path.BIN:
                return OauthRedirectErrorCode.auth_bin_step_cancelled;
            default:
                console.error('Unexpected path for error code detection');
                return OauthRedirectErrorCode.server_error;
        }
    }
}
